import { z } from 'zod';
import { api } from '@/utils/api';
const vendorSchema = z.object({id:z.string(),name:z.string(),gstin:z.string().nullable().optional()}).passthrough();
const pageSchema = z.object({data:z.array(vendorSchema),pagination:z.object({total:z.number().int().nonnegative(),totalPages:z.number().int().nonnegative()})});
export type VendorOption = z.infer<typeof vendorSchema>;
/** Load the complete selector through supported page sizes; never expose a partial list. */
export async function loadVendorOptions(signal: AbortSignal): Promise<VendorOption[]> {
  const vendors: VendorOption[] = [];
  let pages=1,total=0;
  for(let page=1;page<=pages;page++) {
    if(signal.aborted)throw new Error('Supplier loading cancelled');
    const response=await api.get('/vendors',{params:{page,limit:100},signal});
    const result=pageSchema.parse(response.data);
    if(page===1){pages=result.pagination.totalPages;total=result.pagination.total;}
    if(result.pagination.total!==total||result.pagination.totalPages!==pages||(total>0&&!result.data.length))throw new Error('Supplier list changed. Reload it to continue.');
    vendors.push(...result.data);
  }
  if(vendors.length!==total||new Set(vendors.map(v=>v.id)).size!==vendors.length)throw new Error('Supplier list changed. Reload it to continue.');
  return vendors;
}
